import Container from '@/components/Container'
import { GxIcon } from '@garpix/garpix-web-components-react'
import React from 'react'
import {
  vkIcon,
  logoFrt,
  usersIcon
} from '@/images'
import style from '../styles/layout.module.scss'
import { Link } from 'react-router-dom'
import { usePage } from '@/hooks'

const Footer = (): React.ReactElement => {
  const page = usePage()

  const { footer } = page.init_state.global.menus
  const { vk_link: vkLink = '/' } =
    page.init_state.global.config

  const currentDate = Date.now()
  const visitorsFormatter = new Intl.NumberFormat('ru')
  
  // Получаем текущий год
  const currentYear = new Date().getFullYear()

  const visitorsCounter = visitorsFormatter.format(
    Math.ceil(currentDate / 1000 / 410 + 31940 + 500000)
  )

  return (
    <footer className={style.footer}>
      <Container>
        <div className={style.footer_top}>
          <a href='mailto:obuchenie@fondrt.ru' className={style.footer__mail}>
            obuchenie@fondrt.ru
          </a>
          <div className={style.footer_counter}>
            <GxIcon src={usersIcon} className={style.footer_counter__icon} />
            Посетители:
            <span className={style.footer_counter__number}>
              {visitorsCounter}
            </span>
          </div>
          <div className={style.footer_social}>
            <a
              href={vkLink}
              target='_blank'
              rel='noopener noreferrer'
              className={style.footer_social__link}
            >
              <GxIcon src={vkIcon} className={style.footer_social__icon} />
            </a>
          </div>
        </div>

        <div className={style.footer_bottom}>
          <p className={style.footer__copyright}>
            © 2014-{currentYear} ППК «Фонд развития территорий». Все права
            защищены.
          </p>
          <ul className={style.footer_links}>
            <li className={style.footer_links__item}>
              <a
                href='https://фрт.рф'
                target='_blank'
                rel='noopener noreferrer'
                className={style.footer_links__link}
              >
                <img
                  src={logoFrt}
                  className={style.footer_links__logo}
                  width='161px'
                  height='29px'
                  alt='Реформа ЖКХ'
                />
              </a>
            </li>
          </ul>

          <nav className={style.footer_menu}>
            {footer.map((el) => {
              return (
                <Link
                  key={el.id}
                  to={el?.property_link_value ?? ''}
                  className={style.footer__policy}
                >
                  {el.name}
                </Link>
              )
            })}
          </nav>
        </div>
      </Container>
    </footer>
  )
}

export default Footer